import React from "react";
import { useTranslation } from "react-i18next";
import { CardBasic, PrimaryLink } from "extranet-component-library";
import { getCardSvg } from "../utils/parsers";
const { REACT_APP_BASE_URL } = process.env;

interface CustomProps {
    movements: Array<any>;
    carnet: any;
    capping: any;
}

const WalletCard = ({ movements, carnet, capping }: CustomProps) => {
    const { t } = useTranslation();

    return (
        <div className="wallet-card">
            <CardBasic
                content={
                    <div className="flex-container justify-end">
                        <div className="card-img">
                            {carnet && carnet.profileId ? (
                                <img src={getCardSvg()} alt="Imagen de la tarjeta Única del TRANSPORT PÚBLIC DE MALLORCA" />
                            ) : null}
                        </div>
                        <div className="flex-container center">
                            <div className="item">
                                <div className="light-text">{t("card.my_card")}</div>
                                <div className="bold-text">{carnet && carnet.tim ? carnet.tim : ''}</div>
                            </div>
                            <div className="item">
                                <div className="light-text">
                                    {t("headers.totalAmount")}
                                </div>
                                <div className="bold-text">
                                    {movements[0].totalAmount ? movements[0].totalAmount : 0}
                                </div>
                            </div>
                            <div className="item">
                                <div className="light-text">
                                    {t("headers.totalPoints")}
                                </div>
                                <div className="bold-text">
                                    {movements[0].totalPoints ? movements[0].totalPoints : 0}
                                </div>
                            </div>
                            {/*
                            <div className="item">
                                <div className="light-text">
                                    {t("headers.capping")}
                                </div>
                                <div className="bold-text">
                                    {capping ? capping : 0}
                                </div>
                            </div>
                            */}
                        </div>
                        <div className="button-wallet-card">
                            <PrimaryLink
                                text={t("card_recharge")}
                                linkUrl={`${REACT_APP_BASE_URL}/${t("urls.charge_card")}`}
                            />
                        </div>
                    </div>
                }
            />
        </div>
    );
};

export default WalletCard;
